import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {ArtistsService} from 'src/app/admin/artists/artists.service';
import {environment} from 'src/environments/environment.prod';

@Component({
    selector: 'app-artists-simple-search',
    templateUrl: './artists-simple-search.component.html',
    styleUrls: ['./artists-simple-search.component.scss'],
    standalone: false
})
export class ArtistsSimpleSearchComponent implements OnInit, OnChanges {
  selectedUsers: any[] = [];
  searchUserName = '';
  dropdownUser = false;
  deployUrl: string;
  users: any[] = [];
  usersBase: any[];
  excludeList: any[] = [];
  initializedFromInput = false;

  @Input() addMultipleUsers = false;
  @Input() excludeListIn: any[] = [];
  @Input() preselected: any[] = [];
  @Output() usersSelected = new EventEmitter<any[]>();

  @ViewChild('dropdownMenu') dropdownMenu: ElementRef;
  @ViewChild('inputSearch') inputField: ElementRef;

  constructor(private artistsService: ArtistsService) {}

  ngOnInit(): void {
    this.deployUrl = environment.deploy_url;
    this.excludeList = [...this.excludeListIn];

    this.initFromPreselected();
    this.getUsers(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['preselected']) {
      this.initFromPreselected();
    }
  }

  resetSearch() {
    this.getUsers(false);
    this.users = this.usersBase;
    this.selectedUsers = [];
  }

  private normalizeUser = (u: any) => ({
    id: u?.id,
    name: u?.name,
    thumbnail: u?.thumbnail || u?.profile_photo || null,
  });

  private initFromPreselected() {
    if (this.initializedFromInput) return;
    if (!this.preselected || !this.preselected.length) return;

    const looksCanonical = 'thumbnail' in (this.preselected[0] || {});
    this.selectedUsers = looksCanonical ? [...this.preselected] : this.preselected.map(this.normalizeUser);

    if (!this.addMultipleUsers && this.selectedUsers.length > 1) {
      this.selectedUsers = [this.selectedUsers[0]];
    }

    const mapById = new Map(this.excludeList.map(u => [u.id, u]));
    this.selectedUsers.forEach(u => mapById.set(u.id, u));
    this.excludeList = Array.from(mapById.values());

    this.usersSelected.emit(this.selectedUsers);
    this.initializedFromInput = true;
  }

  getUsers(showDropdown = true) {
    this.artistsService.artistsSearch({q: this.searchUserName}).subscribe((data: any) => {
      if (this.excludeList.length > 0) {
        this.users = data.filter(item1 => !this.excludeList.some(item2 => item2.id === item1.id));
        this.usersBase = this.users;
      } else {
        this.users = data;
        this.usersBase = data;
      }
      if (showDropdown) {
        this.dropdownUser = true;
      }
    });
  }

  recomputeAvailable() {
    if (!this.usersBase) return;
    this.users = this.usersBase.filter(item1 => !this.excludeList.some(item2 => item2.id === item1.id));
  }

  setUser(user: any) {
    this.dropdownUser = false;
    this.searchUserName = '';

    if (!this.addMultipleUsers) {
      this.selectedUsers = [];
      this.excludeList = [...this.excludeListIn];
    }

    const normalized = this.normalizeUser(user);
    const exists = this.selectedUsers.some(u => u.id === normalized.id);
    if (!exists) {
      this.selectedUsers.push(normalized);
      this.excludeList.push(normalized);
    }

    this.recomputeAvailable();
    this.usersSelected.emit(this.selectedUsers);
  }

  removeSelectedUser(user: any, index: number) {
    this.selectedUsers.splice(index, 1);
    this.usersSelected.emit(this.selectedUsers);
    this.excludeList = this.excludeList.filter(item => item.id !== user.id);
    this.recomputeAvailable();
  }

  getImagePath() {
    return this.deployUrl + 'assets/icons/cancel-icon.svg';
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const clickedInsideDropdown = this.dropdownMenu?.nativeElement.contains(event.target);
    const clickedInsideInput = this.inputField?.nativeElement.contains(event.target);

    if (!clickedInsideDropdown && !clickedInsideInput) {
      this.dropdownUser = false;
    }
  }
}
